import React from 'react';

import { cn } from '../../../lib/utils';
import Typography from '../../../Typography/Typography';

import { MfaStatusMessageType } from './status-message.enum';


interface StatusMessageProps {
  type?: MfaStatusMessageType;
  message: string;
  className?: string;
}

const StatusMessage: React.FC<StatusMessageProps> = ({
  message,
  className,
  type = MfaStatusMessageType.INFO,
}) => {
  const colorMap = {
    [MfaStatusMessageType.SUCCESS]: 'text-emerald-500', 
    [MfaStatusMessageType.ERROR]: 'text-base-destructive',
    [MfaStatusMessageType.INFO]: 'text-base-foreground'
  };

  return (
    <Typography
      className={cn('text-center text-p-s', colorMap[type], className)}
    >
      {message}
    </Typography>
  );
};

export default StatusMessage;



